import { createSlice } from '@reduxjs/toolkit';
import { User, Token } from 'pages/Auth/auth.types';
import {
  getUser,
  signIn,
  signInGoogle,
  signInGoogleComlete,
  signUp,
  updateUserProfile,
} from 'services/auth/auth.service';

interface authSliceType {
  loading: boolean;
  user: User | null;
  tokens: Token | null;
}

const initialState = {
  loading: false,
  user: null,
  tokens: null,
} as authSliceType;

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    removeUserFromState(state) {
      state.user = null;
    },
  },

  extraReducers: (builder) => {
    // SIGN UP
    builder.addCase(signUp.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(signUp.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.user = payload.user;
      state.tokens = payload.tokens;
    });
    builder.addCase(signUp.rejected, (state) => {
      state.loading = false;
    });

    // SIGN IN
    builder.addCase(signIn.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(signIn.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.user = payload.user;
      state.tokens = payload.tokens;
    });
    builder.addCase(signIn.rejected, (state) => {
      state.loading = false;
    });

    // GOOGLE SIGN IN
    builder.addCase(signInGoogle.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(signInGoogle.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.user = payload.user;
      state.tokens = payload.tokens;
    });
    builder.addCase(signInGoogle.rejected, (state) => {
      state.loading = false;
    });

    // GOOGLE SIGN IN
    builder.addCase(signInGoogleComlete.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(signInGoogleComlete.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.user = payload.user;
      state.tokens = payload.tokens;
    });
    builder.addCase(signInGoogleComlete.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUser.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.user = payload;
    });
    builder.addCase(getUser.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(updateUserProfile.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateUserProfile.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.user!.firstName = payload.firstName;
      state.user!.lastName = payload.lastName;
      state.user!.username = payload.username;

      if (payload.profileImage) {
        state.user!.username = payload.username;
        state.user!.profileImage = payload.profileImage;
      }
    });
    builder.addCase(updateUserProfile.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { removeUserFromState } = authSlice.actions;

export default authSlice.reducer;
